<template>
  <div class="content-wrapper d-lg-block" :class="{'d-none': isMobileMenuOpen}">
    <mobile-top @close-mobile-menu="close_mobile_menu"></mobile-top>

    <div id="news-widget-container" class="h-100 w-100 overflow-hidden"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MobileTop from './MobileTop.vue'

export default {
  props: ['isMobileMenuOpen'],
  components: {
    MobileTop
  },
  computed: {
    ...mapState({
      user_theme: state => state.user_theme.user_theme
    })
  },
  mounted () {
    this.loadFJWidget()
  },
  watch: {
    user_theme () {
      this.loadFJWidget()
    }
  },
  methods: {
    loadFJWidget () {
      const jo = document.createElement('script')
      jo.type = 'text/javascript'
      jo.id = 'FJ-Widgets'
      const r = Math.floor(Math.random() * 10000)
      jo.src = 'https://feed.financialjuice.com/widgets/widgets.js?r=' + r

      jo.onload = () => {
        const options = {
          container: 'news-widget-container',
          mode: this.user_theme ? 'Dark' : 'Light',
          width: '100%',
          height: '980px',
          backColor: this.user_theme ? '34393e' : 'f5f8fa',
          fontColor: this.user_theme ? 'b2b5be' : '353b40',
          widgetType: 'NEWS'
        }

        window.FJWidgets.createWidget(options)
      }

      document.head.appendChild(jo)
    },
    close_mobile_menu () {
      this.$emit('close-mobile-menu')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
